export default __webpack_public_path__ + "static/desktop-2x-933fed35f5fbba37dfcee97077fd9543.jpeg";